import type { SupabaseClient } from '../../lib/supabase';

/**
 * The accounts AI agents act through (profiles.is_agent, 20270181000100 F1).
 * Thumbs appear only on their messages (F4).
 *
 * A separate small read on purpose, not a new column on the shared comment
 * query: if this page ships before migration 181 has been run by hand, this
 * one query fails and the thumbs simply do not show, while every comment
 * thread in the Hub keeps loading.
 */
export async function fetchAgentIds(client: SupabaseClient): Promise<Set<string>> {
  const { data, error } = await client.from('profiles').select('id').eq('is_agent', true);
  if (error) {
    throw new Error(error.message);
  }
  return new Set((Array.isArray(data) ? data : []).map((row: { id: string }) => row.id));
}
